import Loader from "react-loader-spinner";
import momenJalaali from "moment-jalali";
import { faBroom, faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Card, Col, Form, FormCheck, Row } from "react-bootstrap";
import { EyeFill, EyeSlashFill, FileEarmarkExcelFill, List, Reply, ReplyFill, Search } from "react-bootstrap-icons";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { searchComplaints, deleteComplaint } from "../store/api/ComplaintsAPI";
import DatePicker from "react-datepicker2";
import ModalSelectUser from "../../Components/Modals/ModalSelectUser";
import BihamtaTable from "../../Components/BihamtaTable";
import { useEffect, useRef, useState } from "react";
import { exportToExcel, setDialog } from "../../store/api/CommonFunctions";
import ModalReferDocument from "../Components/ModalReferDocument";
import { setReferDocPop } from "../store/api/Modals";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const SearchComplaints = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const frmFilters = useRef();
    const { handleSubmit, register } = useForm();
    const [showFilter, setShowFilter] = useState(true);
    const [updateBy, setUpdateBy] = useState(null);
    const [createBy, setCreateBy] = useState(null);
    const [closedBy, setClosedBy] = useState(null);
    const [popUser, setPopUser] = useState({ show: false });
    const [pending, setPending] = useState(false);
    const filterData = useSelector(state => state.ComplaintsReducer.complaintFilters);
    const deadlineSearch = useRef(false);
    const [dateFilters, setDateFilters] = useState({
        CloseDateFrom: filterData?.CloseDateFrom,
        CloseDateTo: filterData?.CloseDateTo,
        CreationDateFrom: filterData?.CreationDateFrom,
        CreationDateTo: filterData?.CreationDateTo,
        UpdateDateFrom: filterData?.UpdateDateFrom,
        UpdateDateTo: filterData?.UpdateDateTo
    })
    function showHideFilter(hide) {
        const divFilters = document.getElementById("divFilters");
        if (hide) {
            divFilters.classList.add("hiddenRow");
            setShowFilter(false);
        }
        else {
            divFilters.classList.remove("hiddenRow");
            setShowFilter(true);
        }
    }
    function clearFilters() {
        frmFilters.current.reset();
        setDateFilters({});
        setUpdateBy(null);
        setCreateBy(null);
        setClosedBy(null);
        dispatch(searchComplaints({ Take: 10, Skip: 0 }));
    }
    function showCreateBy() {
        filterData.CreateByID = null;
        filterData.CreateByName = null;
        setPopUser({ show: true, selectUserWithName: setCreateBy });
    }
    function showUpdateBy() {
        filterData.UpdateByID = null;
        filterData.UpdateByName = null;
        setPopUser({ show: true, selectUserWithName: setUpdateBy });
    }
    function showCloseBy() {
        filterData.CloseByID = null;
        filterData.CloseName = null;
        setPopUser({ show: true, selectUserWithName: setClosedBy });
    }
    function search(data) {
        data.Skip = 0;
        if(deadlineSearch.current)
        {
            data.DeadlineDateTo = new Date();
            data.DeadlineDateTo.setDate(data.DeadlineDateTo.getDate() -1);
        }
        const createFrom = document.getElementsByName("CreationDateFrom")[0].value;
        if (createFrom !== "") {
            data.CreationDateFrom = dateFilters.CreationDateFrom
        }
        else {
            dateFilters.CreationDateFrom = null;
        }
        const createTo = document.getElementsByName("CreationDateTo")[0].value;
        if (createTo !== "") {
            data.CreationDateTo = dateFilters.CreationDateTo;
        }
        else {
            dateFilters.CreationDateTo = null;
        }
        const closeFrom = document.getElementsByName("CloseDateFrom")[0].value;
        if (closeFrom !== "") {
            data.CloseDateFrom = dateFilters.CloseDateFrom;
        }
        else {
            dateFilters.CloseDateFrom = null;
        }
        const closeTo = document.getElementsByName("CloseDateTo")[0].value;
        if (closeTo !== "") {
            data.CloseDateTo = dateFilters.CloseDateTo;
        }
        else {
            dateFilters.CloseDateTo = null;
        }
        const updateFrom = document.getElementsByName("UpdateDateFrom")[0].value;
        if (updateFrom !== "") {
            data.UpdateDateFrom = dateFilters.UpdateDateFrom;
        }
        const updateTo = document.getElementsByName("UpdateDateTo")[0].value;
        if (updateTo !== "") {
            data.UpdateDateTo = dateFilters.UpdateDateTo;
        }

        dispatch(searchComplaints(data));
    }
    function toExcel() {
        const url = "api/ComplaintsAPI/SearchComplaints";
        const searchArgs = { ...filterData };
        searchArgs.Skip = 0;
        searchArgs.Take = 0;
        setPending(true);
        exportToExcel("ComplaintList", searchArgs, url, "post", tableCols, () => setPending(false));
    }
    const tableCols = [
        { colTitle: "ردیف", colName: "RowNumber", showInMobile: true },
        { colTitle: "تاریخ ثبت", colName: "PCreationDate", showInMobile: true },
        { colTitle: "نام مشتری", colName: "CustomerName", showInMobile: true },
        { colTitle: "همراه مشتری", colName: "CustomerMobile", showInMobile: true },
        { colTitle: "تلفن مشتری", colName: "CustomerTel" },
        { colTitle: "سریال محصول", colName: "ProductSerial", style: { fontFamily: "Dark-Sans", fontSize: "11.5px" } },
        { colTitle: "عنوان شکایت", colName: "Title" },
        { colTitle: "اولویت", colName: "Priority" },
        { colTitle: "وضعیت", colName: "Status" },
        { colTitle: "فرجام یافته", colName: "IsClosed", colType: "boolean" }
    ]
    const buttons = [
        {
            type: "show", title: "نمایش شکایت", className: "group-Btn-smalll btn-info", onclick: showComp
        },
        {
            type: "common", title: "ارجاع به کاربر", tooltip: "ارجاع به کاربر", icon: <ReplyFill size={19} color="green" className="rowBtn" />, onclick: (item) => showDocRefer(item.ID)
        },
        {
            type: "delete", title: "حذف شکایت", className: "group-Btn-smalll btn-danger", onclick: delComp
        }
    ]
    function delComp(item) {
        const onDelete = (res) => {
            if (res === "success") {
                search(filterData);
            }
        }
        dispatch(setDialog({
            status: 'show',
            arrayBtn: ['yes', 'no'],
            dialogTitle: 'حذف شکایت',
            dialogText: 'آیا از حذف مطمئن هستید؟',
            okOperation: () => { return deleteComplaint(item.ID, onDelete) }
        }))
    }
    function showComp(item) {
        history.push(`/CRM/Complaint/${item.ID}/0/0`);
    }
    function showDocRefer(id) {
        dispatch(setReferDocPop({ show: true, documentHardCode: "complaint", documentID: id }));
    }
    useEffect(() => {
        document.body.classList = "notMain";
        document.title = "بی همتا-مشتریان";
    }, [])
    return (
        <div className="container-fluid mt-2">
            <br />
            <Card>
                <ModalSelectUser popData={popUser} setUserPop={setPopUser} />
                <ModalReferDocument />
                <Card.Header className="headerStyle">
                    <FontAwesomeIcon icon={faSearch} size="lg" />&nbsp;جستجوی شکایات
                </Card.Header>
                <Card.Body className="bodyStyle" style={{ minHeight: '75vh' }}>
                    <form readOnly onSubmit={handleSubmit(search)} ref={frmFilters}>
                        <Row id="divFilters" className="rowBorder">
                            <div className="rowTitle">
                                فیلترهای جستجو
                                &nbsp;
                                {showFilter && <EyeSlashFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(true)} />}
                                {!showFilter && <EyeFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(false)} />}
                                {showFilter && <FontAwesomeIcon icon={faBroom} size="lg" style={{ cursor: "pointer", color: "#007e80" }} onClick={clearFilters} />}
                            </div>
                            <Col md={2} className="form-group">
                                <label>نام مشتری: </label>
                                <input className="search-input" name="CustomerName" ref={register()} defaultValue={filterData?.CustomerName ?? ""} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>شماره همراه مشتری: </label>
                                <input className="search-input" name="CustomerMobile" ref={register()} defaultValue={filterData?.CustomerMobile ?? ""} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>تلفن مشتری: </label>
                                <input className="search-input" name="CustomerTel" ref={register()} defaultValue={filterData?.CustomerTel ?? ""} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>عنوان شکایت: </label>
                                <input className="search-input" name="Title" ref={register()} defaultValue={filterData?.Title ?? ""} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>متن شکایت: </label>
                                <input className="search-input" name="Body" ref={register()} defaultValue={filterData?.Body ?? ""} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>کد(شماره) رهگیری</label>
                                <input className="search-input" name="TrackingNumber" ref={register()} defaultValue={filterData?.TrackingNumber ?? ""} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>سریال محصول: </label>
                                <input className="search-input" name="ProductSerial" ref={register()} defaultValue={filterData?.ProductSerial ?? ""} style={{ fontFamily: "Dark-Sans", fontSize: "11.5px" }} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>تاریخ فرجام از:</label>
                                <DatePicker isGregorian={false} timePicker={false} className="search-input" name="CloseDateFrom"
                                    value={dateFilters.CloseDateFrom ? momenJalaali(dateFilters.CloseDateFrom) : null}
                                    onChange={value => setDateFilters({ ...dateFilters, CloseDateFrom: value.local("en").format("YYYY-MM-DD") })} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>تاریخ فرجام تا:</label>
                                <DatePicker isGregorian={false} timePicker={false} className="search-input" name="CloseDateTo"
                                    value={dateFilters.CloseDateTo ? momenJalaali(dateFilters.CloseDateTo) : null}
                                    onChange={val => setDateFilters({ ...dateFilters, CloseDateTo: val.local("en").format("YYYY-MM-DD") })} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>تاریخ ثبت از:</label>
                                <DatePicker isGregorian={false} timePicker={false} className="search-input" name="CreationDateFrom"
                                    value={dateFilters.CreationDateFrom ? momenJalaali(dateFilters.CreationDateFrom) : null}
                                    onChange={value => setDateFilters({ ...dateFilters, CreationDateFrom: value.local("en").format("YYYY-MM-DD") })} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>تاریخ ثبت تا:</label>
                                <DatePicker isGregorian={false} timePicker={false} className="search-input" name="CreationDateTo"
                                    value={dateFilters.CreationDateTo ? momenJalaali(dateFilters.CreationDateTo) : null}
                                    onChange={val => setDateFilters({ ...dateFilters, CreationDateTo: val.local("en").format("YYYY-MM-DD") })} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>تاریخ ویرایش از:</label>
                                <DatePicker isGregorian={false} timePicker={false} className="search-input" name="UpdateDateFrom"
                                    value={dateFilters.UpdateDateFrom ? momenJalaali(dateFilters.UpdateDateFrom) : null}
                                    onChange={value => setDateFilters({ ...dateFilters, UpdateDateFrom: value.local("en").format("YYYY-MM-DD") })} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>تاریخ ویرایش تا:</label>
                                <DatePicker isGregorian={false} timePicker={false} className="search-input" name="UpdateDateTo"
                                    value={dateFilters.UpdateDateTo ? momenJalaali(dateFilters.UpdateDateTo) : null}
                                    onChange={val => setDateFilters({ ...dateFilters, UpdateDateTo: val.local("en").format("YYYY-MM-DD") })} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>ثبت کننده:</label>
                                <input type="hidden" name="CreateByID" value={createBy?.ID ?? filterData?.CreateByID ?? ""} ref={register({})} />
                                <input className="search-input" readOnly onKeyDown={showCreateBy} name="CreateByName" ref={register({})}
                                    value={createBy?.Name ?? filterData?.CreateByName ?? ""} />
                                <Button className="btn-input-tiny" onClick={showCreateBy} style={{top:23}}><List size={17} /></Button>
                            </Col>
                            <Col md={2} className="form-group">
                                <label>ویرایش کننده:</label>
                                <input type="hidden" name="UpdateByID" value={updateBy?.ID ?? filterData?.UpdateByID ?? ""} readOnly ref={register({})} />
                                <input className="search-input" readOnly onKeyDown={showUpdateBy} value={updateBy?.Name ?? filterData?.UpdateByName ?? ""} name="UpdateByName" ref={register({})} />
                                <Button className="btn-input-tiny" onClick={showUpdateBy}  style={{top:23}}><List size={17} /></Button>
                            </Col>
                            <Col md={2} className="form-group">
                                <label>ثبت فرجام توسط:</label>
                                <input type="hidden" name="CloseByID" value={updateBy?.ID ?? filterData?.CloseByID ?? ""} readOnly ref={register({})} />
                                <input className="search-input" readOnly onKeyDown={showCloseBy} value={closedBy?.Name ?? filterData?.CloseByName ?? ""} name="CloseByName" ref={register({})} />
                                <Button className="btn-input-tiny" onClick={showCloseBy}  style={{top:23}}><List size={17} /></Button>
                            </Col>
                            <Col md={2} className="form-group">
                                <label>تعداد در صفحه: </label>
                                <select className="search-input" name="Take" ref={register()} defaultValue={filterData?.Take ?? 10}>
                                    <option value={0}>انتخاب کنید</option>
                                    <option value={10}>10 ردیف  در صفحه</option>
                                    <option value={20}>20 ردیف  در صفحه</option>
                                    <option value={50}>50 ردیف  در صفحه</option>
                                    <option value={100}>100 ردیف  در صفحه</option>
                                </select>
                            </Col>
                            <Col md={2} className="form-group">
                                <label>مرتب سازی براساس: </label>
                                <select className="search-input" name="OrderBy" ref={register()} defaultValue={filterData?.OrderBy ?? "CreateDate"}>
                                    <option value="CreateDate">تاریخ ثبت-صعودی</option>
                                    <option value="CreateDate Desc">تاریخ ثبت-نزولی</option>
                                    <option value="Priority">اولویت-صعودی</option>
                                    <option value="Priority Desc">اولویت-نزولی</option>
                                    <option value="Influence">تاثیر بر سازمان-صعودی</option>
                                    <option value="Influence Desc">تاثیر بر سازمان-نزولی</option>
                                    <option value="Deadline">مهلت فرجام-صعودی</option>
                                    <option value="Deadline Desc">مهلت فرجام-نزولی</option>
                                </select>
                            </Col>
                        </Row>
                        <Button className="group-Btn-large mt-1" type="submit" onMouseDown={()=>deadlineSearch.current = false}><Search size={16} />&nbsp;جستجوی شکایات</Button>
                        <Button variant="secondary" className="group-Btn-large mt-1" type="submit" onMouseDown={()=>deadlineSearch.current = true}><Search size={16} />&nbsp;فهرست تاخیر در پاسخ</Button>
                    </form>
                    {!pending && <div style={{ padding: 0, width: "100%", textAlign: "left" }}><FileEarmarkExcelFill onClick={toExcel} size={25} color="green" style={{ cursor: "pointer" }} className="hoverIcon" /></div>}
                    {pending && <div style={{ padding: 0, width: "100%", textAlign: "left" }}><Loader type="BallTriangle" color="#bb1370" height={18} style={{ textAlign: "left", alignItems: "left" }} /></div>}
                    <BihamtaTable className="mt-1" style={{ whiteSpace: "nowrap" }} columns={tableCols} rowButtons={buttons} reducerName="ComplaintsReducer"
                        objectName="complaintList" filterData={filterData} searchMethod={(data) => dispatch(searchComplaints(data))} hasPaging={true} />
                </Card.Body>
            </Card>
        </div>)
}
export default SearchComplaints;